<ng-container [formGroup]="subcontractorCertificateForm">
  <div class="card-body">
    <h2>Subcontractor Certificates</h2>

    <ng-container formArrayName="certificates">

      @for (certificate of certificates()?.controls; track certificate; let i = $index) {
        <ng-container  [formGroupName]="i">
          <div class="form-row">
            <div class="form-group col-12">
              <mat-slide-toggle formControlName="is_certified" (change)="addValidationToCertificate($event,i)">{{ certificates().at(i)?.get('name')?.value }}</mat-slide-toggle>
            </div>
          </div>
          @if (certificates().at(i)?.get('is_certified')?.value) {
            @if (certificates().at(i)?.get('is_expiration')?.value == 1) {
              <mat-form-field appearance="fill" class="input_datepicker">
                <mat-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="expiration_date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              @if (certificates().at(i).get('expiration_date')?.invalid) {
                <div class="mb-2">
                  <small class="text-danger">This field is required</small></div>
                }
              }
              @if (certificates().at(i)?.get('is_file_uploaded')?.value == 1) {
                <div class="form-row">
                  <div class="form-group col-12">
                    <label class="custom_label">Select File</label>
                    <app-attachment [dropZoneId]="'certificate'+i" (onDelete)="onDeleteCertificateFile(i)" (callback)="attachment($event, i)" [module_id]="21"
                    [fileTypes]="fileTypes" [imageOnEdit]="certificates().at(i)?.get('attachment')?.value"></app-attachment>
                    @if (certificates().at(i).get('file_id')?.invalid) {
                      <div class="mb-2">
                        <small class="text-danger">This field is required</small></div>
                      }
                    </div>
                    <!--<app-attachment (callback)="attachment($event, i)" [module_id]="21"></app-attachment>-->
                  </div>
                }
              }
            </ng-container>
          }



        </ng-container>



        <!-- <div class="form-row">
        <div class="form-group col-12">
          <label for="name" class="custom_label">Phone *</label>
          <input matInput phoneMask type="text" id="phone" formControlName="phone" class="form-control" placeholder="Phone" name="phone">
          <app-validation-error [formGroup]="addSubcontractorForm" [controlName]="'phone'"></app-validation-error>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-12">
          <label for="name" class="custom_label">Alternate Phone *</label>
          <input matInput phoneMask type="text" id="alternate_phone" formControlName="alternate_phone" class="form-control" placeholder="Alternate Phone" name="alternate_phone">
          <app-validation-error [formGroup]="addSubcontractorForm" [controlName]="'alternate_phone'"></app-validation-error>
        </div>
      </div>-->

    </div>
  </ng-container>
